import React, { forwardRef } from 'react';
import ProductSelector from '../PurchaseOrders/ProductSelector';

const formatVentasCatalogLabel = (entry) => {
  if (!entry) return '';
  if (entry.catalog_type === 'offer') {
    return `${entry.name} (${entry.sku})`;
  }
  return `${entry.name} - ${entry.sku}`;
};

const VentasCatalogSelector = forwardRef((props, ref) => (
  <ProductSelector
    ref={ref}
    {...props}
    formatOptionLabel={formatVentasCatalogLabel}
    optionBadge={(entry) => (entry?.catalog_type === 'offer' ? 'Oferta' : null)}
    matchOptionValue={(item, value) => String(item?.id) === String(value)}
    skipEnsureForValue={(value) => String(value ?? '').startsWith('offer-')}
    searchEmptyMessage="No se encontraron productos ni ofertas"
    searchLoadingMessage="Buscando productos y ofertas..."
  />
));

VentasCatalogSelector.displayName = 'VentasCatalogSelector';

export default VentasCatalogSelector;
